import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const newbornBedtime: BlogMetaData = {
  title: '新生児の寝かしつけ｜生後0〜3ヶ月のコツとモンテッソーリ流・昼夜のリズムの整え方',
  description:
    '新生児の寝かしつけに悩む方へ。生後0〜3ヶ月はまだ睡眠リズムがなく昼夜の区別もつかない時期です。縦抱きやおくるみ、トッポンチーノを使った入眠のコツ、安心できる環境づくり、昼夜のリズムを少しずつ整える方法をモンテッソーリの視点でやさしく解説します。',
  thumbnailUrl: '/img/blog-newborn-bedtime.webp',
  filePath: buildBlogFilePath('newborn-bedtime'),
  category: BLOG_CATEGORY.PARENTING,
};
